"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var context_1 = require("./context");
var unique_id_1 = require("./lib/unique-id");
var rect_coord_1 = require("./coordinates/rect-coord");
var line_1 = require("./shapes/line");
var legend_1 = require("./helpers/legend");
var tooltip_1 = require("./helpers/tooltip");
var bar_1 = require("./shapes/bar");
var pie_1 = require("./shapes/pie");
var polar_coord_1 = require("./coordinates/polar-coord");
var selection_1 = require("./helpers/selection");
var event_1 = require("./event");
var annotation_1 = require("./helpers/annotation");
var shapes_1 = require("./shapes");
var noop = function () { };
var Chart = /** @class */ (function () {
    /**
     * 初始化图表
     * @param container HTML 根元素
     * @param customTheme 主题配置
     */
    function Chart(container, customTheme, context) {
        /**
         * 坐标系实例
         * @since 2.0
         */
        this.coordinates = {};
        /**
         * 辅助图层/功能实例集合
         * @since 2.0
         */
        this.helpers = {};
        this.id = unique_id_1.uniqueId("chart_");
        this.ctx = context || new context_1.Context(this.id, container, customTheme);
        this.helpers.legend = new legend_1.Legend(this.ctx);
        this.helpers.tooltip = new tooltip_1.Tooltip(this.ctx);
        this.helpers.selection = new selection_1.Selection(this.ctx);
        this.helpers.annotation = new annotation_1.Annotation(this.ctx);
        this.events = new event_1.Events(this.ctx, this.helpers);
    }
    /**
     * 设置数据源
     * @param dataSource 原始数据源
     * @since 2.0
     */
    Chart.prototype.source = function (dataSource) {
        this.ctx.setDataSource(dataSource);
        return this;
    };
    /**
     * 设置主题
     * @param config 主题选项
     * @since 2.0
     */
    Chart.prototype.theme = function (config) {
        if (typeof config === "object" && !Array.isArray(config)) {
            this.ctx.setTheme(config);
        }
        return this;
    };
    /**
     * 设置数据源的列
     * @param scaleCfg 列定义
     * @since 2.0
     */
    Chart.prototype.scale = function (scaleCfg) {
        if (scaleCfg) {
            this.ctx.setOption("scale", scaleCfg);
        }
        return this;
    };
    /**
     * 设置提示框
     * @param enable 是否显示提示框
     * @param TooltipCfg 提示框配置
     * @since 2.0
     */
    Chart.prototype.tooltip = function (enable, TooltipCfg) {
        if (TooltipCfg === void 0) { TooltipCfg = {}; }
        var cfg = typeof enable === "boolean" ? tslib_1.__assign({ enable: enable }, TooltipCfg) : tslib_1.__assign({}, enable);
        cfg.enable = typeof cfg.enable === "boolean" ? cfg.enable : true;
        this.ctx.setOption("tooltip", cfg);
        return this;
    };
    /**
     * 设置图例
     * @param enable 是否显示图例
     * @param legendCfg 图例配置
     * @since 2.0
     */
    Chart.prototype.legend = function (enable, legendCfg) {
        if (legendCfg === void 0) { legendCfg = {}; }
        var cfg = typeof enable === "boolean" ? tslib_1.__assign({ enable: enable }, legendCfg) : tslib_1.__assign({}, enable);
        cfg.enable = typeof cfg.enable === "boolean" ? cfg.enable : true;
        this.ctx.setOption("legend", cfg);
        return this;
    };
    /**
     * 交互事件
     * @param type 交互类型
     * @param extra 交互类型额外参数
     * @since 2.1.0
     */
    Chart.prototype.interaction = function (type, extra) {
        if (extra === void 0) { extra = {}; }
        this.ctx.setOption("interaction." + type, extra);
        return this;
    };
    /**
     * 注释
     *
     * @since 2.1.0
     */
    Chart.prototype.annotation = function () {
        return this.helpers.annotation;
    };
    Chart.prototype.line = function () {
        if (!this.coordinates.rect) {
            this.coordinates.rect = new rect_coord_1.RectCoordinate(this.ctx, this.helpers);
        }
        var line = new line_1.Line(this.ctx, this.coordinates.rect, this.helpers);
        this.shape = line;
        return line;
    };
    Chart.prototype.area = function () {
        if (!this.coordinates.rect) {
            this.coordinates.rect = new rect_coord_1.RectCoordinate(this.ctx, this.helpers);
        }
        var area = new shapes_1.Area(this.ctx, this.coordinates.rect, this.helpers);
        this.shape = area;
        return area;
    };
    Chart.prototype.bar = function () {
        if (!this.coordinates.rect) {
            this.coordinates.rect = new rect_coord_1.RectCoordinate(this.ctx, this.helpers);
        }
        var bar = new bar_1.Bar(this.ctx, this.coordinates.rect, this.helpers);
        this.shape = bar;
        return bar;
    };
    Chart.prototype.pie = function () {
        if (!this.coordinates.polar) {
            this.coordinates.polar = new polar_coord_1.PolarCoordinate(this.ctx, this.helpers);
        }
        var pie = new pie_1.Pie(this.ctx, this.coordinates.polar, this.helpers);
        this.shape = pie;
        return pie;
    };
    Chart.prototype.map = function () {
        var map = new shapes_1.Map(this.ctx, this.helpers);
        this.shape = map;
        return map;
    };
    /**
     * 开始渲染
     * @since 2.0
     */
    Chart.prototype.render = function () {
        var _a = window.getComputedStyle(this.ctx.container), widthStr = _a.width, heightStr = _a.height;
        var width = widthStr === "auto" ? 0 : parseInt(widthStr, 10);
        var height = heightStr === "auto" ? 0 : parseInt(heightStr, 10);
        if (Number.isNaN(width) || Number.isNaN(height))
            return;
        this.updateSize(width, height);
        if (this.shape) {
            this.shape.draw();
            this.helpers.annotation.draw();
            this.reorder();
            this.ctx.emit("chart.rendered");
        }
    };
    /**
     * 销毁图表实例
     * @since 2.0
     */
    Chart.prototype.destroy = function () {
        // this.ctx.container.innerHTML = "";
        this.helpers.tooltip.hide();
        // this.ctx.removeAllListeners();
        // this.ctx.setOption("interaction", {});
    };
    /**
     * 监听事件
     * @param eventName 事件名
     * @param callback 事件回调函数
     * @callback TeaChart.EventListenerCallback
     * @since 2.0
     */
    Chart.prototype.on = function (eventName, callback) {
        if (callback === void 0) { callback = noop; }
        this.ctx.addListener(eventName, callback);
    };
    /**
     * 发送事件
     * @param eventName 事件名
     * @param eventData 事件数据
     * @since 2.0
     */
    Chart.prototype.emit = function (eventName, eventData) {
        this.ctx.emit(eventName, eventData);
    };
    /**
     * 监听事件
     * @param eventName 事件名
     * @param callback 事件回调函数
     * @callback TeaChart.EventListenerCallback
     * @since 2.0
     */
    Chart.prototype.once = function (eventName, callback) {
        if (callback === void 0) { callback = noop; }
        this.ctx.once(eventName, callback);
    };
    /**
     * 删除事件绑定
     * @param eventName 事件名
     * @param callback 事件回调函数
     * @callback TeaChart.EventListenerCallback
     * @since 2.3
     */
    Chart.prototype.off = function (eventName, callback) {
        if (callback === void 0) { callback = noop; }
        this.ctx.off(eventName, callback);
    };
    /**
     * 重置尺寸
     * @since 2.0
     */
    Chart.prototype.resize = function () {
        var _this = this;
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(function () {
            _this.render();
        }, 500);
    };
    /**
     * 更新图表尺寸
     * @private
     * @event chart.sizeUpdated
     * @since 2.0
     */
    Chart.prototype.updateSize = function (width, height) {
        this.ctx.root
            .attr("width", width)
            .attr("height", height)
            .attr("viewBox", "0 0 " + width + " " + height);
        this.ctx.background
            .attr("x", 0)
            .attr("y", 0)
            .attr("width", width)
            .attr("height", height);
        this.ctx.emit("chart.sizeUpdated", { width: width, height: height });
    };
    /**
     * 重新按照元素的 data-z-index 属性排列各个图层
     * @since 2.0
     */
    Chart.prototype.reorder = function () {
        var maxIndex = 7;
        for (var start = 0; start <= maxIndex; start++) {
            this.ctx.root.selectAll("[data-z-index=\"" + start + "\"]").raise();
        }
    };
    return Chart;
}());
exports.Chart = Chart;
//# sourceMappingURL=chart.js.map